import './OrderTableDisplayFilter.style.less'

import { Button, Checkbox, Dropdown, Menu, Select } from 'antd'
import { useEffect, useState } from 'react'

import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { useTranslation } from 'react-i18next'
import { isEmptyValue, parseJSON } from '@/utils/common'
import {
  concat,
  difference,
  filter,
  find,
  isEmpty,
  map,
  matchesProperty,
  size,
} from 'lodash'
import { ORDER_CUSTOM_COLUMNS_TYPE } from '@/screens/Order/Pages/Order.transform'

type Props = {
  onChange: (value: string[]) => any
  dataSource: ORDER_CUSTOM_COLUMNS_TYPE[]
  user?: any
}

const getExistingDisplayFN = (userId) => {
  const getLocalOrderDisplay = parseJSON(localStorage.getItem('OrderDisplay'))
  if (!size(getLocalOrderDisplay)) {
    return {}
  }

  const getExistingDisplay = find(
    getLocalOrderDisplay,
    matchesProperty('userId', userId)
  )

  return getExistingDisplay
}

function OrderTableDisplayFilter(props: Props) {
  const { dataSource, user } = props
  const { id: userId } = user
  const { t } = useTranslation()

  const [selected, setSelected] = useState<string[]>([])
  const [visible, setVisible] = useState(false)

  const _onApply = (value?: any) => props.onChange(value ?? selected)

  useEffect(() => {
    const defaultColumns = map(
      filter(dataSource, (item) => item.type === 'default'),
      'key'
    )
    const existingDisplay = getExistingDisplayFN(userId)

    const columns = size(existingDisplay)
      ? existingDisplay?.columns
      : defaultColumns

    setSelected(columns)
    _onApply(columns)
  }, [dataSource])

  if (isEmpty(dataSource)) {
    return <></>
  }

  const handleChange = () => {
    const newEntry: any = { userId, columns: selected }
    const getExistingData = parseJSON(localStorage.getItem('OrderDisplay'))

    const currentUserEntry: any = getExistingDisplayFN(userId)

    const updateData = size(currentUserEntry)
      ? map(getExistingData, (item) =>
        item.userId === currentUserEntry.userId ? newEntry : item
      )
      : concat(getExistingData, newEntry)

    localStorage.setItem('OrderDisplay', JSON.stringify(updateData))
  }

  const mapCountSelectItem = () => {
    const getApiItemDefault = filter(
      dataSource,
      ({ type, fromApi }) => type === 'default' && fromApi
    )
    const presentKeys = map(getApiItemDefault, 'key')
    const getCount = size(difference(selected, presentKeys))
    const resultCountStr = `${getCount} Column${getCount > 1 ? 's' : ''}`

    return resultCountStr
  }

  const handleOnReset = () => {
    const getDefaultAll = filter(
      dataSource,
      ({ type, fromApi }) => type === 'default' && fromApi
    )
    const getKeyColumns = map(getDefaultAll, 'key')
    const result = concat(['order_number', 'progress_status'], getKeyColumns)

    setSelected(result)
  }

  return (
    <div>
      <Dropdown
        open={visible}
        overlay={
          <Menu
            onMouseLeave={() => {
              setVisible(false)
            }}
          >
            {map(dataSource, (field, i) => {
              if (field.type === 'default' && field.fromApi) {
                return <></>
              }
              return (
                <div key={field.key}>
                  <Menu.Item>
                    <Checkbox
                      checked={selected?.includes(field.key)}
                      disabled={i === 0}
                      onChange={(value: CheckboxChangeEvent) => {
                        if (value.target.checked)
                          setSelected([...selected, field.key])
                        else {
                          setSelected(
                            selected.filter((item) => item !== field.key)
                          )
                        }
                      }}
                    >
                      {t(field.value)}
                    </Checkbox>
                  </Menu.Item>
                </div>
              )
            })}
            <hr />
            <div className="btn-display-filter">
              <Button
                size="small"
                className="btn-reset"
                onClick={handleOnReset}
              >
                Reset
              </Button>
              <Button
                size="small"
                className="btn-apply"
                onClick={() => {
                  _onApply()
                  handleChange()
                  setVisible(!visible)
                }}
              >
                Apply
              </Button>
            </div>
          </Menu>
        }
        placement="topRight"
      >
        <Select
          className="select select-empty"
          dropdownStyle={{ display: 'none' }}
          placeholder="Select Columns"
          size="large"
          value={mapCountSelectItem()}
          style={{ width: 160 }}
          onClick={() => {
            setVisible(!visible)
          }}
        />
      </Dropdown>
    </div>
  )
}

export default OrderTableDisplayFilter
